<template>
<v-flex class="neg-margin text-xs-center" xs12>
  <div class="neg-margin banner-bg pt-5 elevation-2"><div class="neg-margin pt-5 banner-mask"><div class="neg-fix pt-3">
    <v-layout row wrap justify-center>
      <v-flex class="py-3" xs12 md10 lg8>
        <v-tabs class="pa-0 ma-0" v-model="tab" color="transparent" slider-color="secondary" centered>
          <v-tab ripple><b>Welcome</b></v-tab>
          <v-tab ripple><b>NCLEX</b></v-tab>
          <v-tab ripple><b>Remedial</b></v-tab>
          <v-tab ripple><b>General</b></v-tab>
          <v-tab ripple><b>For Schools</b></v-tab>
          <v-tab-item>
            <v-jumbotron :height="width < 350 ? '500px' : width < 450 ? '475px' : '350px'">
              <v-container fill-height>
                <v-layout align-center>
                  <v-flex xs12>
                    <v-avatar tile size="175">
                      <img src="/static/img/RophemLOGO_2019_500px.png" alt="Logo">
                    </v-avatar>
                    <h1 class="pb-1 spaced">Rophem Nursing Academy</h1>
                    <h3 class="pb-3 spaced">NCLEX Review &nbsp;&nbsp;|&nbsp;&nbsp; Nursing CE &nbsp;&nbsp;</h3>
                    <v-btn to="/about" class="mt-3" color="secondary" depressed large><b>About Us</b></v-btn>
                    <v-btn to="https://www.rophemnursing.com/blog/categories/testimonials" class="mt-3" color="secondary" depressed large><b>Testimonials</b></v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-jumbotron>
          </v-tab-item>
          <v-tab-item>
            <v-jumbotron :height="width < 350 ? '500px' : width < 450 ? '475px' : '350px'">
              <v-container fill-height>
                <v-layout align-center>
                  <v-flex xs12>
                    <h1 class="pb-1 caps spaced">nclex courses</h1>
                    <h3 class="pb-3">We offer in class and online NCLEX review courses that provide content review, critical thinking and test taking strategies and access to over 2000 NCLEX styled questions proven to enhcance your success on the exam</h3>
                    <v-btn to="https://www.rophemnursing.com/nclex-prep" color="secondary" depressed large>Course Info</v-btn>
                    <v-btn to="/register" color="secondary" depressed large>Register</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-jumbotron>
          </v-tab-item>
          <v-tab-item>
            <v-jumbotron :height="width < 350 ? '500px' : width < 450 ? '475px' : '350px'">
              <v-container fill-height>
                <v-layout align-center>
                  <v-flex xs12>
                    <h1 class="pb-1 caps spaced">remedial</h1>
                    <h3 class="pb-3">Our FL BON approved remedial course consists of 80 hours of theory and 96 hours of clinical training designed to help you pass the NCLEX and become a safe and skilled nurse or resume safe practice after years of inactivity</h3>
                    <v-btn to="https://www.rophemnursing.com/remedial-course" color="secondary" depressed large>Course Info</v-btn>
                    <v-btn to="/register" color="secondary" depressed large>Register</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-jumbotron>
          </v-tab-item>
          <v-tab-item>
            <v-jumbotron :height="width < 350 ? '500px' : width < 450 ? '475px' : '350px'">
              <v-container fill-height>
                <v-layout align-center>
                  <v-flex xs12>
                    <h1 class="pb-1 caps spaced">other courses</h1>
                    <h3 class="pb-3">Already a nurse? No worries, we’ve got you covered too! We offer complete Continuing Education for Nurses</h3>
                    <v-btn to="https://www.rophemnursing.com/ce" color="secondary" large depressed>Nurisng CE</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-jumbotron>
          </v-tab-item>
          <v-tab-item>
            <v-jumbotron :height="width < 350 ? '500px' : width < 450 ? '475px' : '350px'">
              <v-container fill-height>
                <v-layout align-center>
                  <v-flex xs12>
                    <h1 class="pb-1 caps spaced">for schools</h1>
                    <h3 class="pb-3">Are you a nursing school wanting to improve your NCLEX passing rate? We'll customize an NCLEX review built to equip your graduates with the tools they need to pass.</h3>
                    <v-btn color="secondary" disabled large depressed>Coming Soon</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-jumbotron>
          </v-tab-item>
        </v-tabs>
      </v-flex>
      <v-flex xs12></v-flex>
      <v-flex class="text-xs-center" xs4 md3 lg2>
        <v-layout row justify-center>
          <v-flex xs11 sm6 md5>
            <v-btn
              @click.native="playPause(false)"
              v-if="sliderPlayer"
              class="my-0"
              color="secondary"
              :loading="stopStarting"
              :disabled="stopStarting"
              flat
              block
              small
            ><v-icon>pause</v-icon></v-btn>
            <v-btn
              @click.native="playPause(true)"
              v-else
              class="my-0"
              color="success"
              :loading="stopStarting"
              :disabled="stopStarting"
              flat
              block
              small
            ><v-icon>play_arrow</v-icon></v-btn>
            <v-progress-linear class="mt-1 mb-2" height="2" color="primary" :value="percent"></v-progress-linear>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div></div></div>

  <v-layout id="upcoming" class="py-4" row wrap justify-center>
    <v-flex class="pt-3" xs12>
      <h1 class="caps spaced">Upcoming Classes</h1>
    </v-flex>
    <v-flex v-if="loading" class="py-5 text-xs-center" xs12>
      <v-progress-circular color="secondary" indeterminate></v-progress-circular>
    </v-flex>
    <v-flex v-else xs12 md11 lg9>
      <v-tabs class="pa-0 ma-0" v-model="subjectTab" color="transparent" slider-color="secondary" centered>
        <v-tab class="spaced" v-for="(sub, i) in allSubjects" :key="i" ripple><b>{{sub}}</b></v-tab>
        <v-tab-item v-for="(sub, i) in allSubjects" :key="i">
          <v-layout row wrap justify-center>
            <v-flex v-if="!publishedExists(sub)" class="py-5 text-xs-center" xs12>
              <div class="display-2 secondary--text pb-3">No {{sub}} Courses</div>
              <div class="display-2 secondary--text">Check back soon!</div>
            </v-flex>
            <v-flex v-else xs12 md10 lg9>
              <v-layout row wrap justify-center>
                <v-flex class="pa-3" v-for="(c, i) in courses" v-if="c[0].subject == sub" :key="i" xs12 sm9 md6>
                  <r-course-card :now="now" :courses="c"></r-course-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs>
    </v-flex>
    <v-flex class="pb-0" xs12>
      <v-btn to="/register" color="secondary">Register</v-btn>
    </v-flex>
  </v-layout>

  <v-layout row justify-center>
    <v-flex xs4 md3>
      <v-divider class="pb-1"></v-divider>
    </v-flex>
  </v-layout>

  <v-layout id="why" class="py-4" row wrap justify-center>
    <v-flex class="pb-4" xs12>
      <h1 class="caps spaced">Why choose rophem?</h1>
    </v-flex>
    <v-flex class="pb-3 pt-2" xs4 md2>
      <div class="box-outline">
        <div class="box-shaded headline"><b>1.</b></div>
      </div>
    </v-flex>
    <v-flex class="text-xs-left pt-1" xs8 md6>
      <h1 class="caps title pb-2"><b>INTERACTIVE LIVE CLASS</b></h1>
      <p class="subheading"><b>Our classes are designed to engage and encourage participation with in-class critical thinking questions and activities.</b></p>
    </v-flex>
    <v-flex class="pb-3" xs12></v-flex>
    <v-flex class="pb-3 pt-2" xs4 md2>
      <div class="box-outline">
        <div class="box-shaded headline"><b>2.</b></div>
      </div>
    </v-flex>
    <v-flex class="text-xs-left pt-1" xs8 md6>
      <h1 class="caps title pb-2"><b>HIGH QUALITY AT AN AFFORABLE PRICE</b></h1>
      <p class="subheading"><b>Our NCLEX Review packages are flexible to suit your needs and situation. Our quality is proven with over 96% pass rate, and at a lower cost than most of our competitors!</b></p>
    </v-flex>
    <v-flex class="pb-3" xs12></v-flex>
    <v-flex class="pb-3 pt-2" xs4 md2>
      <div class="box-outline">
        <div class="box-shaded headline"><b>3.</b></div>
      </div>
    </v-flex>
    <v-flex class="text-xs-left pt-1" xs8 md6>
      <h1 class="caps title pb-2"><b>CARING INSTRUCTORS</b></h1>
      <p class="subheading"><b>At Rophem, your success is our goal, and our instructors have the skill and knowledge to get you there!</b></p>
    </v-flex>
    <v-flex class="pb-4" xs12></v-flex>
    <v-flex xs9 sm6>
      <h1 class="caps title pb-2"><b>See what students are saying about us</b></h1>
      <v-btn to="https://www.rophemnursing.com/blog/categories/testimonials" color="secondary" large>Testimonials</v-btn>
    </v-flex>
  </v-layout>

  <r-register-popup :popup="popup" :course-data="courseData" :payment-id="paymentId"></r-register-popup>
</v-flex>
</template>

<script>
import RegisterPopup from '../courses/RegisterPopup.vue'
import CourseCard from '../courses/CourseCard.vue'
import {coursesEvent} from '../../../main'
export default {
  components: {
    rRegisterPopup: RegisterPopup,
    rCourseCard: CourseCard
  },
  data: () => ({
    tab: '0',
    oldTab: '0',
    sliderPlayer: null,
    stopStarting: false,
    subjectTab: 0,
    courseData: {},
    allSubjects: ['RN', 'PN'],
    timer: 0,
    subject: '',
    loading: false,
    width: Infinity,
    widthChanger: null,
    stripeHandler: null,
    paymentId: null,
    popup: {
      show: false,
      type: ''
    }
  }),
  computed: {
    now () {
      return this.$store.getters.now
    },
    user () {
      return this.$store.getters.user
    },
    percent () {
      return (this.timer / 5000) * 100
    },
    allCourses () {
      return this.$store.getters.courses
    },
    publishedExists () {
      return (subject) => {
        for (let course of this.allCourses) {
          if (course.subject === subject && course.published) return true
        }
        return false
      }
    },
    courses () {
      const live = []
      let added = false
      for (let course of this.allCourses) {
        if (course.type === 'Live' && course.published && course.subject === this.allSubjects[this.subjectTab]) {
          for (let group of live) {
            if (group[0].name === course.name) {
              group.push(course)
              added = true
              group.sort((a, b) => {
                return parseInt(a.onlineDays, 10) - parseInt(b.onlineDays, 10)
              })
            }
          }
          if (!added && live.length < 2) live.push([course])
          added = false
        }
      }
      live.sort((a, b) => {
        return (new Date(a[0].dates[0])).valueOf() - (new Date(b[0].dates[0])).valueOf()
      })
      return live
    }
  },
  beforeMount () {
    coursesEvent.$off()
    this.load()
    coursesEvent.$on('registerPopup', key => {
      this.registerPopup(key)
    })
    coursesEvent.$on('canRegister', key => {
      this.canRegister(key)
    })
  },
  beforeDestroy () {
    if (this.stripeHandler) {
      this.stripeHandler.close()
      this.stripeHandler = null
    }
    this.pauseSlider()
    this.cleanUp()
  },
  methods: {
    load () {
      this.loading = true
      this.widthChanger = setInterval(() => {
        if (this.width !== window.innerWidth) this.width = window.innerWidth
      }, 1000)
      this.playPause(true)
      window.addEventListener('focus', () => {
        this.playPause(true)
      })
      window.addEventListener('blur', () => {
        this.playPause(false)
      })
      this.initStripe()
      if (this.$store.getters.coursesModuleLoaded) this.loading = false
      else {
        this.$store.dispatch('loadCourses').then(() => {
          this.loading = false
        })
      }
    },
    initStripe () {
      if (this.user) {
        if (!this.stripeHandler) {
          this.stripeHandler = window.StripeCheckout.configure({
            // key: 'pk_test_geD37HCkE8ySbfE3XtmnUg3t',
            key: 'pk_live_fpuUBwtcYSOS2opPTIIJAQ3o',
            email: this.user.email,
            zipCode: true,
            allowRememberMe: false,
            token: token => {
              this.processPayment(token)
            }
          })
        }
      }
    },
    requestPayment () {
      let course = this.$store.getters.courseByKey(this.$store.getters.courseToRegister)
      this.stripeHandler.open({
        name: 'Rophem Nursing Academy',
        description: course.name + ', ' + course.onlineDays + ' days online',
        amount: parseInt(course.price) * 100
      })
    },
    processPayment (token) {
      let course = this.$store.getters.courseByKey(this.$store.getters.courseToRegister)
      let newPayment = {
        courseKey: course.key,
        studentId: this.user.uid,
        amount: parseInt(course.price) * 100,
        description: course.name + ', ' + course.onlineDays + ' days online',
        date: this.now,
        token: token
      }
      this.popup = {
        show: true,
        type: 'Registering'
      }
      this.$store.dispatch('addPayment', newPayment).then(paymentId => {
        this.paymentId = paymentId
      })
    },
    playPause (play) {
      this.stopStarting = true
      setTimeout(() => {
        if (play) this.playSlider()
        else this.pauseSlider()
        this.stopStarting = false
      }, 250)
    },
    playSlider () {
      if (this.sliderPlayer) return
      this.sliderPlayer = setInterval(() => {
        if (this.$route.fullPath !== '/') this.pauseSlider()
        this.timer += 1000
        if (this.oldTab !== this.tab) {
          this.timer = 0
          this.oldTab = this.tab
        }
        if (this.timer > 5000) {
          this.timer = 0
          let t = (parseInt(this.tab, 10) + 1) % 4
          this.tab = t.toString(10)
          this.oldTab = this.tab
        }
      }, 1000)
    },
    pauseSlider () {
      while (this.sliderPlayer) {
        clearInterval(this.sliderPlayer)
        this.sliderPlayer = null
      }
    },
    cleanUp () {
      while (this.widthChanger) {
        clearInterval(this.widthChanger)
        this.widthChanger = null
      }
    },
    registerPopup (key) {
      this.courseData = this.$store.getters.courseByKey(key)
      this.popup.show = true
      this.popup.type = 'Register'
    },
    canRegister (key) {
      this.$store.dispatch('setCourseToRegister', key)
      if (this.user) {
        // if (this.user.type === 'Admin') this.register()
        // else this.requestPayment()
        this.requestPayment()
      } else {
        const appMsg = {
          type: 'error',
          msg: 'Please sign in to register!'
        }
        this.$store.dispatch('showAppMsg', appMsg)
      }
    },
    register () {
      let newProgress = {
        name: this.courseData.name,
        url: '',
        courseKey: this.courseData.key,
        studentId: this.user.uid,
        onlineDays: this.courseData.onlineDays,
        endTime: 0
      }
      let courseProgress = this.$store.getters.progressByCourseByStudent(this.courseData.key, this.user.uid)
      newProgress.url = this.$store.getters.formatUrl(this.courseData.name)
      newProgress.url = newProgress.url + '-' + (courseProgress.length + 1).toString()
      let newCourse = {
        ...this.courseData,
        students: this.courseData.students ? [...this.courseData.students] : []
      }
      this.$store.dispatch('createProgress', newProgress).then(() => {
        if (this.user.type.toLowerCase() === 'student') newCourse.students.push(this.user.uid)
        this.$store.dispatch('updateCourse', newCourse).then(() => {
          let appMsg = {
            type: 'success',
            msg: 'Registerd for ' + newCourse.name
          }
          this.$store.dispatch('showAppMsg', appMsg)
          this.$router.push('/my-courses')
        })
      })
    }
  }
}
</script>

<style scoped>
.box-outline {
  border: #555 solid 2px;
  padding-top: 7px;
  padding-left: 7px;
  width: 70px;
  margin: 0 auto;
}
.box-shaded {
  /* background-color: #aaa; */
  background-color: rgba(130, 130, 130, 0.7);
  margin-right: -12px;
  margin-bottom: -10px;
  padding: 15px 35px 25px 25px; 
}
</style>



// WEBPACK FOOTER //
// src/components/site/home/Home.vue